import { numConvert } from "@/method";
import { setKarte } from '@/method/analysis';
import request from '@/method/request';
import _ from 'lodash';

export const getChart = async year => {

    const { data: { data = [], area = [], last = [] } } = await request(`/chartData7_2?year=${year}`);
    const dataX = new Array(12).fill(1).map((x, i) => `${i + 1}月`);
    console.log(data);
    setKarte({
        id: "row1",
        title: "Associate Turnover % 员工离职率%",
        color: ['#00C5BD', '#42585D', '#FE5F5F'],
        yAxis: {
            max: 15, interval: 1
        },
        dataX, dataY: [
            {
                name: "今年",
                data: dataX.map((x, i) => numConvert(_.get(data.find(_x => _x.month == (i + 1)), 'thisy_employee_num', 0) * 100).toFixed(2))
            },
            {
                name: "去年",
                data: dataX.map((x, i) => numConvert(_.get(data.find(_x => _x.month == (i + 1)), 'lasty_employee_num', 0) * 100).toFixed(2))
            },
            {
                name: "区域",
                data: dataX.map((x, i) => numConvert(_.get(area.find(_x => _x.month == (i + 1)), 'thisy_employee_num', 0) * 100).toFixed(2))
            }
        ]
    });

}


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-2/compute.js